import React, { useState } from 'react';
import axios from 'axios';
import { load } from 'cheerio';

const ZillowDescriptionFetcher = () => {
  const [url, setUrl] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');

  const fetchDescription = async () => {
    try {
      const response = await axios.get(url, {
        headers: {
          'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/91.0.4472.124 Safari/537.36',
          'Accept-Language': 'en-US,en;q=0.9',
          'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8',
          'Referer': 'https://www.google.com/',  // Makes it look like you're coming from Google
          'Connection': 'keep-alive'
        }
      });

      const $ = load(response.data);
      const descriptionText = $('article div div').text().trim();

      if (descriptionText) {
        setDescription(descriptionText);
        setError('');
      } else {
        setDescription('');
        setError('Description not found. Please check the URL or the selector.');
      }
    } catch (err) {
      setDescription('');
      setError(`Error fetching description: ${err.message}`);
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-2xl shadow-md space-y-4">
      <h1 className="text-xl font-bold">Zillow Property Description Fetcher</h1>
      <input
        type="text"
        placeholder="Enter Zillow URL"
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        className="w-full p-2 border rounded-xl"
      />
      <button
        onClick={fetchDescription}
        className="w-full bg-blue-500 text-white p-2 rounded-xl hover:bg-blue-600 transition"
      >
        Fetch Description
      </button>
      {description && (
        <div className="bg-green-100 p-4 rounded-xl">
          <h2 className="font-semibold">Property Description:</h2>
          <p>{description}</p>
        </div>
      )}
      {error && (
        <div className="bg-red-100 p-4 rounded-xl">
          <h2 className="font-semibold text-red-600">Error:</h2>
          <p>{error}</p>
        </div>
      )}
    </div>
  );
};

export default ZillowDescriptionFetcher;
